import { render } from "./ModalProfTaxInfo.vue?vue&type=template&id=0828bfee&scoped=true"
import script from "./ModalProfTaxInfo.vue?vue&type=script&lang=js"
export * from "./ModalProfTaxInfo.vue?vue&type=script&lang=js"

import "./ModalProfTaxInfo.vue?vue&type=style&index=0&id=0828bfee&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0828bfee"]])

export default __exports__